// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__29V8z","image":"Header_image__PLnyW","name":"Header_name__2z0mI","info":"Header_info__1MZOA","infoRow":"Header_infoRow__2sFcG"};